import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import { toast } from "react-toastify";
import { Formik, Form } from "formik";
import useIpLocation from "../hooks/useIpLocation";
import { PageHeader, Card, Stepper } from "fiver-react-ui-components";
import moment from "moment";
import { SignupSchema } from "./schema";
import { defaultTranslations } from "./defaultTranslations";
import { logXtremepush } from "@low6dev/react-utils/dist";
import { isSafari, isMobileSafari, isIE, isAndroid, isChrome } from "react-device-detect";
import SignupStep1 from "./SignupStep1";
import SignupStep2 from "./SignupStep2";
import SignupStep3 from "./SignupStep3";
import SignupStep4 from "./SignupStep4";
import ConfirmStep from "./ConfirmStep";
const StyledWrapper = styled.div``;

const Signup = ({
  translations,
  isGenericMobileError,
  onSuccess,
  onError,
  onPageButtonClicked,
  termsSlug,
  useAssetsCdn,
  privacySlug,
  smsSlug,
  disableAgeValidation,
  showHasTotoAccountCheckbox,
  hidePostcode,
  hideGdprCheckboxes,
  hidePushNotifcationCheckbox,
  hideSmsCheckbox,
  hideEmailCheckbox,
  hideCheckAllCheckbox,
  hideMobileNumberCheckbox,
  hideMobileNumberAlert,
  hideMobileVerificationMessage,
  hideStepper,
  showGenericSignUpError,
  isMobileVerificationDisabled,
  isSavingPicks,
  hasTextboxDatePicker,
  hasDropdownDatePicker,
  isNonUkForced,
  forcedCountryCode,
  dateInputFormat = "DD/MM/YYYY",
  tenantDetails,
  gameRulesSlug,
  uncheckConsentBoxesByDefault,
  hasCustomPrivacy
}) => {
  if (!translations) {
    translations = defaultTranslations;
  }

  const [state, setState] = useState({
    activeStep: 0,
    signupError: undefined,
    location: "",
    dialingCode: "",
    isNonUk: undefined
  });
  const initialValues = {
    firstName: "",
    lastName: "",
    birthDate: "",
    mobileNumber: "",
    username: "",
    test: false,
    inAppNotificationsAccepted: false,
    smsNotificationsAccepted: false,
    emailNotificationsAccepted: !uncheckConsentBoxesByDefault,
    agreedTerms: true,
    agreedPrivacy: true,
    checkAll: false,
    enterAddressManually: false,
    postcode: "",
    street1: "",
    street2: "",
    city: "",
    county: "",
    password: "",
    passwordConfirm: "",
    state: "",
    dataSharePermissions: false,
    country: "",
    affiliateNotificationAccepted: !uncheckConsentBoxesByDefault,
    partnerNotificationAccepted: !uncheckConsentBoxesByDefault,
    hasTotoAccount: !uncheckConsentBoxesByDefault
  };

  if (process.env.NODE_ENV === "development") {
    initialValues.firstName = "test";
    initialValues.lastName = "Test";
    initialValues.username = "test3983838";
    initialValues.email = "test@test.com";
    initialValues.birthDate = "01-01-1985";
    initialValues.mobileNumber = "0777777777";
    initialValues.postcode = "B262NJ"; // initialValues.city = "Solihull";
    // initialValues.street1 = "14 Benedon Road";

    initialValues.password = "Password1";
    initialValues.passwordConfirm = "Password1";
  }

  const onLocationSuccess = ({
    country,
    dialingCode,
    isNonUk
  }) => {
    setState({ ...state,
      location: country,
      dialingCode: forcedCountryCode || dialingCode,
      isNonUk
    });
  };

  useIpLocation(onError, onLocationSuccess, isNonUkForced);
  const {
    activeStep,
    location,
    signupError,
    dialingCode,
    isNonUk
  } = state;

  const setActiveStep = activeStep => {
    window.scrollTo(0, 0);
    setState({ ...state,
      activeStep
    });
  };

  const onSubmit = async (values, {
    setSubmitting
  }) => {
    let signupLocation = values.country;
    const params = {
      location,
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
      username: values.username.trim(),
      email: values.email.trim(),
      mobileNumber: `+${dialingCode}${values.mobileNumber.trim()}`,
      password: values.password,
      pin: "1234",
      birthDate: new moment(values.birthDate, dateInputFormat, true).format("YYYY-MM-DD"),
      termsConditionsAccepted: values.agreedTerms,
      email_notifications_accepted: values.emailNotificationsAccepted,
      contactPermissions: {
        emailNotificationsAccepted: values.emailNotificationsAccepted,
        inAppNotificationsAccepted: values.inAppNotificationsAccepted,
        smsNotificationsAccepted: values.smsNotificationsAccepted
      }
    };
    params.address = {
      line1: values.street1.trim(),
      line2: values.street2.trim(),
      city: values.city.trim(),
      county: values.county.trim(),
      postcode: values.postcode.trim().replace(/(-\d+$)|(\s)/g, ""),
      country: values.country.trim()
    };
    params.location = location;
    params.state = values.state.trim();
    params.hasTotoAccount = values.hasTotoAccount;
    params.dataSharePermissions = {
      allPermissions: values.dataSharePermissions,
      partnerSmsAccepted: values.smsNotificationsAccepted,
      partnerEmailAccepted: values.emailNotificationsAccepted,
      partnerNotificationAccepted: values.partnerNotificationAccepted,
      affiliateNotificationAccepted: values.affiliateNotificationAccepted
    };
    let signupRes;

    try {
      signupRes = await axios.post(signupLocation === "United Kingdom" && !isNonUkForced ? "/auth/register" : "/auth/register-non-uk", params);
      const {
        access_token,
        refresh_token
      } = signupRes?.data;
      localStorage.setItem("fiver_react_access_token", access_token);
      localStorage.setItem("fiver_react_refresh_token", refresh_token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
      setSubmitting(false);
      window.xtremepush("event", "Registration.AccountCreated", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));

      if (!isMobileVerificationDisabled) {
        console.log("were getting in here somehow", isMobileVerificationDisabled);

        try {
          await axios.post(`/verification/mobile/send`);
          toast.success(translations.confirmPhoneCodeSent);
        } catch (error) {
          console.log("Error sending verification code");
        }
      }

      let isOver24 = false;

      try {
        const profileRes = await axios.get("/me");
        const profile = profileRes?.data?.data;
        const age = moment().diff(moment(profile?.birthDate, "YYYY-MM-DD"), "years", true);
        isOver24 = age >= 24;
        window.xtremepush("set", "user_id", profile.id); // window.xtremepush("user", "update", {
        //   user_id: profile.id,
        //   email: profile.email,
        //   mobile_number: profile.mobileNumber,
        //   first_name: profile.firstName,
        //   last_name: profile.lastName,
        //   birth_date: profile.birthDate,
        //   age,
        //   isOver24,
        //   tenant_id: process.env.REACT_APP_TENANT,
        //   username: profile.username,
        //   sms_subscription: profile.contactPermissions.smsNotificationsAccepted,
        //   email_subscription:
        //     profile.contactPermissions.emailNotificationsAccepted,
        //   push_subscription:
        //     profile.contactPermissions.inAppNotificationsAccepted,
        // });
      } catch (error) {
        console.log("error getting profile after signup", error);
      }

      onSuccess({
        isOver24
      });
    } catch ({
      response
    }) {
      setSubmitting(false);
      let message = translations?.signUpError;

      if (!showGenericSignUpError && response?.data) {
        if (response?.data?.errors) {
          if (response?.data?.errors?.email) {
            message = response?.data?.errors?.email[0];
          }

          if (response.data.errors.username) {
            message = response?.data?.errors?.username[0];
          }
        } else if (response?.data?.message) {
          message = response?.data?.message;
        }
      }

      setState({ ...state,
        signupError: message
      });
    }
  };

  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: SignupSchema(translations, isGenericMobileError, isNonUk, true, dateInputFormat, disableAgeValidation, hidePostcode),
    onSubmit: onSubmit,
    enableReinitialize: true
  }, ({
    isValid,
    values,
    errors,
    touched,
    dirty,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldError,
    setFieldTouched,
    setTouched,
    validateField,
    setValues,
    isValidating
    /* and other goodies */

  }) => {
    const isStep1Valid = !errors.birthDate && !errors.firstName && !errors.lastName && !errors.postcode && !errors.city && !errors.street1 && !errors.county;
    const isStep2Valid = !errors.mobileNumber && !errors.email;
    const isStep3Valid = !errors.password && !errors.passwordConfirm && !errors.username;
    const isStep4Valid = true;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideStepper && /*#__PURE__*/React.createElement(PageHeader, null, /*#__PURE__*/React.createElement(Stepper, {
      onStepClicked: setActiveStep,
      activeStep: activeStep,
      steps: [{
        isValid: true
      }, {
        isValid: dirty && isStep1Valid
      }, {
        isValid: dirty && isStep1Valid && isStep2Valid
      }, {
        isValid: dirty && isStep1Valid && isStep2Valid && isStep3Valid
      }]
    })), /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(StyledWrapper, null, activeStep === 0 && /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(SignupStep1, {
      dateInputFormat: dateInputFormat,
      showFallbackDatePicker: true,
      translations: translations,
      onStepClicked: setActiveStep,
      isStepValid: isStep1Valid,
      setFieldValue: setFieldValue,
      dirty: dirty,
      values: values,
      errors: errors,
      hidePostcode: hidePostcode,
      hasDropdownDatePicker: hasDropdownDatePicker,
      hasTextboxDatePicker: hasTextboxDatePicker,
      handleChange: handleChange,
      handleBlur: handleBlur,
      setFieldError: setFieldError,
      setFieldTouched: setFieldTouched,
      setTouched: setTouched,
      touched: touched,
      isNonUk: isNonUk
    })), activeStep === 1 && /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(SignupStep2, {
      location: location,
      forcedCountryCode: forcedCountryCode,
      useAssetsCdn: useAssetsCdn,
      translations: translations,
      onStepClicked: setActiveStep,
      onPageButtonClicked: onPageButtonClicked,
      smsSlug: smsSlug,
      isStepValid: isStep2Valid,
      setFieldValue: setFieldValue,
      dirty: dirty,
      values: values,
      errors: errors,
      handleChange: handleChange,
      handleBlur: handleBlur,
      hideMobileVerificationMessage: hideMobileVerificationMessage,
      hideMobileNumberCheckbox: hideMobileNumberCheckbox,
      hideMobileNumberAlert: hideMobileNumberAlert,
      dialingCode: dialingCode,
      setFieldTouched: setFieldTouched,
      touched: touched,
      tenantDetails: tenantDetails
    })), activeStep === 2 && /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(SignupStep3, {
      translations: translations,
      onStepClicked: setActiveStep,
      isStepValid: isStep3Valid,
      dirty: dirty,
      values: values,
      errors: errors,
      handleChange: handleChange,
      handleBlur: handleBlur,
      setFieldTouched: setFieldTouched,
      touched: touched
    })), activeStep === 3 && /*#__PURE__*/React.createElement(SignupStep4, {
      isSavingPicks: isSavingPicks,
      useAssetsCdn: useAssetsCdn,
      translations: translations,
      isSubmitting: isSubmitting,
      onPageButtonClicked: onPageButtonClicked,
      onStepClicked: setActiveStep,
      setValues: setValues,
      isStepValid: isStep4Valid,
      dirty: dirty,
      values: values,
      errors: errors,
      signupError: signupError,
      handleChange: handleChange,
      termsSlug: termsSlug,
      privacySlug: privacySlug,
      hideGdprCheckboxes: hideGdprCheckboxes,
      hidePushNotifcationCheckbox: hidePushNotifcationCheckbox,
      hideSmsCheckbox: hideSmsCheckbox,
      hideEmailCheckbox: hideEmailCheckbox,
      hideCheckAllCheckbox: hideCheckAllCheckbox,
      showHasTotoAccountCheckbox: showHasTotoAccountCheckbox,
      hasCustomPrivacy: hasCustomPrivacy,
      tenantDetails: tenantDetails,
      gameRulesSlug: gameRulesSlug,
      isNonUk: isNonUk
    }), activeStep === 4 && /*#__PURE__*/React.createElement(ConfirmStep, {
      translations: translations,
      isSubmitting: isSubmitting,
      onStepClicked: setActiveStep,
      isStepValid: isStep4Valid,
      dirty: dirty,
      values: values,
      signupError: signupError
    }))));
  });
};

export default Signup;